import React from "react";
import { withStyles } from "@material-ui/core";
import "./placards.css";
import StyledToolTip from "../../../../../common/StyledToolTip";
import { PLACARD_CLASSES_WITH_TEXTBOX, PLACARD_TYPE } from "./constants";
const styles = (theme) => ({
  container: {
    padding: "16px 0 0 16px",
    backgroundColor: theme.ModalBGColor
  },
  header: {
    fontSize: 10,
    lineHeight: "14px",
    color: theme.ModalHeaderTextColor,
  },
  placardImage: {
    display: "flex",
    flexDirection: "column",
    padding: 10,
    backgroundColor: theme.ModalBGColor,
    position:"relative"
  },
  placardImageTooltip:{
    margin:-4 // used for overriding styledtooltip default padding
  },
  imageListcontainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  minImageContainer: {
    transform: "scale(0.25)",
    margin: "-45px",
    cursor: "pointer",
  },
  hazmatDetails: {
    paddingTop: 8,
    fontSize: 10,
    lineHeight: "12px",
    color: theme.ModalHeaderTextColor,
    textAlign: "center",
  },
  placardCount: {
    color: theme.iconColor,
    fontSize:12,
    fontWeight:500
  },
  hazmatUnCodes:{
    fontSize:12,
    position: "absolute",
    textAlign:"center",
    top: "40%",
    fontWeight: 500,
    left: "30%" 
  },
  hazmatUnCodesMin:{
    fontSize:4,
    top: "45%",
  }
  
});

const getHazmatClass = (placard) => {
  const classPrefix = "bg-";
  const typePrefix = placard.type === PLACARD_TYPE.bulk ? "Bulk" : "";
  const classNumber = placard.class.replace(".", "_");
  return `${classPrefix}${typePrefix}${classNumber}`;
};

const HazmatPlacard = ({ placards, classes }) => {
  return (
    <div className={classes.container}>
      <div className={classes.header}>
        Required hazmat placards:
        <span className={classes.placardCount}> {placards.length}</span>
      </div>
      <div className={classes.imageListcontainer}>
        {placards.map((placard) => {
          const hazmatClass = getHazmatClass(placard);
          const showUNCodeInTextBox = PLACARD_CLASSES_WITH_TEXTBOX.includes(hazmatClass);
          return (
            <StyledToolTip
              title={
                <div
                  className={`${classes.placardImageTooltip} ${classes.placardImage}`}
                >
                  <div className={hazmatClass} />
                  <div className={classes.hazmatDetails}>
                    <div>{placard.hazmatUnCodes}</div>
                    <div>{placard.description}</div>
                  </div>
                  {showUNCodeInTextBox && (
                    <div className={classes.hazmatUnCodes}>
                      {placard.hazmatUnCodes}
                    </div>
                  )}
                </div>
              }
              placement="bottom-start"
            >
              <div className={classes.placardImage}>
                <div
                  className={`${classes.minImageContainer} ${hazmatClass}`}
                />
                {showUNCodeInTextBox && (
                  <div
                    className={`${classes.hazmatUnCodes} ${classes.hazmatUnCodesMin}`}
                  >
                    {placard.hazmatUnCodes}
                  </div>
                )}
              </div>
            </StyledToolTip>
          );
        })}
      </div>
    </div>
  );
};

export default withStyles(styles)(HazmatPlacard);
